module.exports = __webpack_public_path__ + "assets/rooms-icon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/rooms-icon.png
// module id = 1217
// module chunks = 7